import styled from 'styled-components';

const ItemWrapper = styled.div`
    display: flex;
    background-color: #fff;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
    &:last-child {
        margin-bottom:0;
    }
`

const ItemImg = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${ props => props.backgroundColor };
    border-radius: 4px;
    flex-basis: 30%;
    height: 70px;
    margin-right: 25px;
    flex-shrink: 0;
    @media screen and (max-width: 768px) {
        height: 50px;
        flex-basis: 20%;
    }
`
const ItemContent = styled.div`
    display: flex;
    align-items:center;
    flex-grow:1;
    @media screen and (max-width: 768px) {
        justify-content: space-between;
    }
`
const ItemBody = styled.div`
    display: flex;
    align-items: center;
    flex-grow:1;
`
const ItemQuantity = styled.p`
    font-size: 18px;
    line-height:1;
    color: #9b9b9b;
    text-transform: capitalize;
    margin:0;
    margin-left: 5px;
`
const ItemName = styled.h6`
    font-size: 18px;
    line-height:1;
    color: #000;
    font-weight:600;
    text-transform: capitalize;
    margin-top: 0;
    margin-bottom: 0;
`
const ItemPrice = styled.p`
    font-size: 18px;
    font-weight: 600;
    line-height:1.5;
    margin-top: 0;
    margin-bottom: 0;
    color: #ff3838;
    text-transform: capitalize;
    margin-left: 10px;
    flex-shrink:0;
`

const Item = props => {
    return (
        <ItemWrapper>
            <ItemImg backgroundColor={props.img} />
            <ItemContent>
                <ItemBody>
                    <ItemName>{props.name}</ItemName>
                    <ItemQuantity>X {props.quantity}</ItemQuantity>
                </ItemBody>
                <ItemPrice>{props.price}</ItemPrice>
            </ItemContent>
        </ItemWrapper>
    )
}
export default Item;